module.exports = new __parcel__URL__("leaderboard_icon.7a32ed87.png").toString();